import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Form, Button, Alert, PageHeader, Divider, Row, Col } from "antd";
import { FormInstance } from "antd/lib/form";
import message from 'antd/lib/message'
import { AlertProps } from "antd/lib/alert";
import { useSearchParam } from 'react-use';
import omit from 'ramda/src/omit'

import { mapFormItemToProps, randomString } from 'src/utils'
import { 
    networkAndroidAttributes as formItems,
    networkAndroidAttribute as formItem
} from 'src/data'
import {FormItemContent, FormItem} from 'src/components/FormItem'
import Container from 'src/components/Container'
import Services from 'src/services'
import { useRequest } from 'src/hooks';
import { EditOutlined } from '@ant-design/icons';
// import CustomBreadcrumb from 'src/components/CustomBreadcrumb'




export function Android(props: any) {
    const { action } = props
    const { id } = useParams<any>()
    const isCopy = action === 'copy'
    const isEdit = !!id

    const [lock, setLock] = React.useState(isEdit && !isCopy)

    const requestUpdate = useRequest(Services.androidNetwork.update)
    const requestAdd = useRequest(Services.androidNetwork.add)
    const requestList = useRequest(Services.androidNetwork.list)
    
    const sdkId = useSearchParam('sdk_id')
    const sdkVersion = useSearchParam('sdk_version')
    
    const [formRef] = React.useState(React.createRef<FormInstance>());
    const history = useHistory();

    const [loading, setLoading] = React.useState<boolean>(false)
    const [alert, setAlert] = React.useState<AlertProps>()

    const toList = () => history.goBack()

    const onFinish = (values: any) => {
        console.log(JSON.stringify(values, null, 4));

        values.adTypes = values.adTypes.join(',')
        
        setLoading(true)
        if(id && !isCopy) {
            requestUpdate({
                    ...values,
                    adNetworkId: id
                })
                .then(() => {
                    message.success('保存成功')
                    toList()
                })
                .finally(() => {
                    setLoading(false)
                })
        } else {
            requestAdd({
                    ...values,
                })
                .then(() => {
                    message.success('新建成功')
                    toList()
                })
                .finally(() => {
                    setLoading(false)
                })
        }
        
    };

    const onFill = (data: any) => {
        if(data === undefined) {
            data = {
                ...formItems.reduce<any>((memo, item) => {
                    memo[item.key] = randomString(16, item.key + '-')
                    return memo
                }, {})
            }
        }
        formRef.current?.setFieldsValue(data);
    }

    const [ versionName, setVersionName ] = React.useState<string>('')
    const [originData, setOriginData] = React.useState<any>({})
    const setData = (res: any[]) => {
        if(!res.length || res.length !== 1) {
            return setAlert({
                type: 'error',
                message: '出错',
                description: '返回数据错误'
            })
        }

        const data = res[0]
        setVersionName(data.adNetworkVersionName)
        data.adTypes = data.adTypes.split(',')

        setOriginData(Object.assign({}, data))

        if(isCopy) {
            // data.adNetworkVersionName = ''
            // data.nameEn = ''
            // data.nameCn = ''
        } 

        // if(sdkId) {
        //     data.sdkId = sdkId
        // }

        
        onFill(data)
    }

    React.useEffect(() => {
        if(id) {
            setLoading(true)
            requestList({adNetworkId: id})
                .then(setData)
                .finally(() => {
                    setLoading(false)
                })
        } else {
            onFill({sdkId})
            formRef.current?.setFieldsValue({isHeaderBidding: '0'})
        }
    }, [id])

    let pageTitle: string = ''
    if(isCopy) {
        pageTitle = `复制Android SDK ${sdkVersion} - 广告网络 ${versionName}`
    } else if(!!id) {
        pageTitle = `编辑Android SDK ${sdkVersion} - 广告网络 ${versionName}`
    } else {
        pageTitle = `新建Android SDK ${sdkVersion} - 广告网络`
    }
    
    const renderFormItem = (formItemTarget: any, options: any = {}) => {
        const {
            labelCol, 
            mixFormItemProps = {},
            mixFormItemContentProps = {},
            suffixComponent = null,
        } = options
        const {
            formItemProps,
            formItemContentProps
        }: any = mapFormItemToProps(formItemTarget)

        

        // if(['nameCn', ].includes(formItemProps.name)) {
        //     formItemProps.rules = []
        // }
        if(lock) {
            formItemContentProps.disabled = true
        }
        
        Object.assign(formItemContentProps, mixFormItemContentProps)
        Object.assign(formItemProps, mixFormItemProps)

        //设置默认值，待验证
        if(formItemTarget.defaultValue) {
            formItemProps.initialValue = formItemTarget.defaultValue
        }

        if(suffixComponent) {
            return (
                <Form.Item labelCol={labelCol} label={formItemProps.label}>
                    <div style={{display: 'flex'}}>
                        <FormItem defaultValue={originData[formItemProps.key]} {...omit(['label'], formItemProps)} noStyle>
                            <FormItemContent {...formItemContentProps} />
                        </FormItem>
                        {suffixComponent}
                    </div>
                </Form.Item>
            )
        }
        return (
                <FormItem labelCol={labelCol} defaultValue={originData[formItemProps.key]} {...formItemProps}>
                    <FormItemContent {...formItemContentProps} />
                </FormItem>
        )
    }

    const [adapterTemplateEditable, setAdapterTemplateEditable] = React.useState(isEdit || isCopy ? false : true)

    return (
    <div>
        {/* <CustomBreadcrumb /> */}
        <PageHeader
            onBack={toList}
            title={pageTitle}
        ></PageHeader>

        {alert && <Alert {...alert}/>}

        <Container loading={loading}>
            <Divider orientation="left" plain>
                基本信息
            </Divider>
    
            <Form labelCol={{lg: {span: 8}, xs:{span: 8}}} ref={formRef} name="control-ref" onFinish={onFinish}>
                {renderFormItem(formItem.sdkId)}
                <Row gutter={24}>
                    <Col span={24}>
                        {renderFormItem(formItem.region, {labelCol: {lg: {span: 4}, xs:{span: 8}}})}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.nameEn)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.nameCn)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.remark_name)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.remark_name_en)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.adNetworkVersionName)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.identification)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.uniqueNetworkId)}
                    </Col>
                    <Col span={24}>
                        {renderFormItem(formItem.adTypes, {labelCol: {lg: {span: 4}, xs:{span: 8}}})}
                    </Col>
                    {/* v 0.8.5 新增 */}
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.isHeaderBidding)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.isAddCrossAndAdx)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.isCoppa)}
                    </Col>


                    <Divider orientation="left" plain />

                    <Col lg={12} span={24}>
                        {
                            renderFormItem(formItem.adapterVersionNameTemplate, {
                                mixFormItemContentProps: {disabled: lock || !adapterTemplateEditable},
                                suffixComponent: !lock && !adapterTemplateEditable ?
                                    <Button icon={<EditOutlined />} style={{marginLeft: '10px'}} onClick={() => setAdapterTemplateEditable(true)}>修改</Button> :
                                    null
                            })
                        }
                        
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.adapterVersionName)}
                    </Col>
                    {/* <Col lg={12} span={24}>
                        {renderFormItem(formItem.androidXCompatible)}
                    </Col> */}
                    {/* <Col lg={12} span={24}>
                        {renderFormItem(formItem.androidSupportCompatible)}
                    </Col> */}
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.isAndroidSupportOrX)}
                    </Col>

                    <Divider orientation="left" plain />

                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.repositories)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.compileOptions)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.dependencies)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.nogradleDependencies)}
                    </Col>
                    <Col lg={12} span={24}>
                        {renderFormItem(formItem.androidManifest)}
                    </Col>

                </Row>
                {
                    /* formItems
                        .map(mapFormItemToProps)
                        .map(({
                            formItemProps,
                            formItemContentProps
                        }: any) => {
                            const {key} = formItemProps
                            // if(['nameCn', ].includes(formItemProps.name)) {
                            //     formItemProps.rules = []
                            // }
                            if(lock) {
                                formItemContentProps.disabled = true
                            }

                            return (
                                <FormItem defaultValue={originData[key]} {...formItemProps}>
                                    <FormItemContent {...formItemContentProps} />
                                </FormItem>
                            )
                        }) */
                }
                <Form.Item 
                    // wrapperCol={{xl:{offset: 4, span: 20}}}
                    style={{textAlign: 'center'}}
                >
                    {lock ? (
                        <Button type="primary" size="large" 
                            onClick={(e) => {
                                setLock(false)
                                e.preventDefault()
                            }} 
                            htmlType="button"
                        >
                            编辑
                        </Button>
                    ) : (
                        <Button type="primary" loading={loading} size="large" htmlType="submit">
                            提交
                        </Button>
                    )}
                    <Button size="large" htmlType="button" onClick={toList}>
                        返回
                    </Button>
                    {/* <Button type="link" htmlType="button" onClick={onFill}>
                        Fill form
                    </Button> */}
                </Form.Item>
            </Form>
        </Container>
    </div>
    );
}
